export function safeParseJSON(value) {

    if (typeof value === 'object' && value !== null) {
        return value;
    }

    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            if (typeof parsed === 'object' && parsed !== null) {
                return parsed;
            }
        } catch {
        }
    }
    return {};
}

/**
 * Recibe un string y valida si se puede parsear a json.
 * Si es válido retorna el objeto JSON { valid: true, json: value }, si no retorna un objeto vacío { valid: false }.
 * @param {*} jsString - Valor a validar (string o objeto).
 * @returns {object} - El objeto JSON válido o {}.
 */
export function validateAndParseJson(jsString) {
    try {
        const parsed = JSON.parse(jsString);
        return {
            valid: true,
            json: parsed ?? {}
        };
    } catch {
        return {
            valid: false,
            json: {}
        };
    }
}

export function isNotEmptyObject(obj) {
    return Object.keys(obj).length > 0;
}

export function getProperty(obj, key) {
    if (obj && typeof obj === "object") {
        return obj.hasOwnProperty(key) ? obj[key] : null;
    }
    return null;
}

export function safeStringifyJSON(value, space = 2) {
    try {
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value, null, space);
        }

        if (typeof value === "string") {
            try {
                const parsed = JSON.parse(value);
                return JSON.stringify(parsed, null, space);
            } catch {
                return value;
            }
        }
    } catch (error) {
    }
    return "{}";
}

export const validateAndEnsureArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                return parsed;
            }
        } catch {
        }
    }
    return [];
};